import { FC } from 'react'
import clsx from 'clsx'

import StatusButtonTooltip from 'components/parts/status-button-tooltip/status-button-tooltip'

import styles from './webinar-start-info.module.scss'

interface IAbandonButton {
  isActive: boolean
}

const AbandonButton: FC<IAbandonButton> = ({ isActive }: IAbandonButton) => (
  <div className={styles.subscribeBlock}>
    <p
      className={clsx(
        styles.subscribeMessage,
        styles.agreeMessageCheckbox,
        styles.agreeMessageAppear,
        {
          [styles.agreeMessageCheckboxActive]: isActive,
        }
      )}
    >
      Вы отписались от вебинара
    </p>
    <p
      className={clsx(styles.subscribeMessage, styles.agreeMessageCheckbox, {
        [styles.agreeMessageCheckboxActive]: !isActive,
      })}
    >
      Вы записались на вебинар! За час до начала напомним вам по почте
    </p>

    <StatusButtonTooltip tooltip={'Отписаться'} isActive={isActive} />
  </div>
)

export default AbandonButton
